import React from 'react';
import PageContainer from 'ui/PageContainer';
import PageHeader from 'ui/PageHeader';
import Tabs from 'ui/Tabs';
import MainImageManager from './MainImageManager';
import NewsManager from './NewsManager';
import PortfolioManager from './PortfolioManager';
import HistoryManager from './HistoryManager';
import ExecutiveManager from './ExecutiveManager';
import PatentVisibilityManager from './PatentVisibilityManager';
import AwardVisibilityManager from './AwardVisibilityManager';
import PressManager from './PressManager';

const WebsiteManagementPage: React.FC = () => {
    const tabs = [
        {
            id: 'main-images',
            label: '메인 이미지',
            content: <MainImageManager />,
        },
        {
            id: 'portfolio',
            label: '수행실적',
            content: <PortfolioManager />,
        },
        {
            id: 'news',
            label: '유원소식',
            content: <NewsManager />,
        },
        {
            id: 'history',
            label: '연혁',
            content: <HistoryManager />,
        },
        {
            id: 'executives',
            label: '경영진',
            content: <ExecutiveManager />,
        },
        {
            id: 'patents',
            label: '특허',
            content: <PatentVisibilityManager />,
        },
        {
            id: 'awards',
            label: '상훈',
            content: <AwardVisibilityManager />,
        },
        {
            id: 'press',
            label: '언론사 보도',
            content: <PressManager />,
        },
    ];

    return (
        <PageContainer>
            <PageHeader
                title="홈페이지 관리"
                subtitle="외부 홈페이지(ywenf.com) 콘텐츠를 관리합니다"
            />
            <Tabs
                tabs={tabs}
                defaultTab="main-images"
                useQueryParam={true}
                queryParamName="tab"
            />
        </PageContainer>
    );
};

export default WebsiteManagementPage;
